module.exports = __webpack_public_path__ + "static/media/chat.95e1f133.svg";